import React, { useCallback, useEffect, useState } from 'react'
import { Row, Col, Collapse } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'
import { Installment } from '../../../models/Installment'
import { Order } from '../../../models/Order'
import { getInstallmentDetail } from '../../../services/installmentService'
import { getOrderDetail } from '../../../services/orderService'
import { formatToPrice } from '../../../utility/prettifynumber'
import { convertDateFormat, getGetOrdinal } from '../../../utility/stringUtils'
import Layout from '../../common/layout/layout'
import styles from './payNextInstallment.module.css'
import { PaymentMethod } from '../../../config/enums'
// import PayWithCard from '../shop/checkout/paymentMethods/payWithCard'
import PayWithPaynow from '../shop/checkout/paymentMethods/payWithPaynow'
import { toast } from 'react-toastify'
import constants from '../../../config/constants'
import PayWithDash from '../shop/checkout/paymentMethods/payWithDash'

interface ParamTypes {
  installmentId: string
  part: string
}

const PayNextInstallment = () => {
  const history = useHistory()
  const { installmentId, part } = useParams<ParamTypes>()
  const [installment, setInstallment] = useState<Installment | undefined>(
    undefined
  )
  const [order, setOrder] = useState<Order | undefined>(undefined)
  const [payMethod, setPayMethod] = useState(PaymentMethod.dash)
  const nextInstallment = parseInt(part)

  useEffect(() => {
    getInstallmentDetail(installmentId).then(detail => {
      setInstallment(detail)
    })
  }, [installmentId])

  useEffect(() => {
    if (!installment) return
    getOrderDetail(installment.orderId).then(detail => {
      setOrder(detail)
    })
  }, [installment])

  const scheduleDueDate = useCallback(() => {
    if (nextInstallment < (installment?.paymentSchedule.length ?? 0)) {
      return installment?.paymentSchedule[nextInstallment].dueDate
    }

    return undefined
  }, [installment, nextInstallment])

  const finalizePayment = () => {
    toast.success(constants.alertMessage.paymentReceived)
    history.push('/orders')
  }

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col>
              <p>Order #{order?.orderNumber}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <h3 className="mb-0">
                {nextInstallment + 1}
                <sup>{getGetOrdinal(nextInstallment + 1)}</sup> installment
              </h3>
              <div className="gray-text">
                due on {convertDateFormat(scheduleDueDate(), false)}
              </div>
            </Col>
            <Col xs="auto">
              <h3>{formatToPrice(installment?.monthlyPayment ?? 0)}</h3>
            </Col>
          </Row>

          <Row className="mt-4">
            <Col>
              <h4 className="sectionTitle">Choose payment method</h4>
            </Col>
          </Row>

          {installment && (
            <Row>
              <Col>
                <div className="box">
                  {/* <div className={styles.boxHeader}>
                    <div
                      onClick={() => {
                        setPayMethod(PaymentMethod.card)
                      }}
                    >
                      <h4>Pay with Dash</h4>
                    </div>
                    <Collapse in={payMethod === PaymentMethod.card}>
                      <div>
                        <PayWithCard
                          order={order}
                          amountPayable={installment.monthlyPayment}
                          isKYCDone={true}
                          onPayButtonClick={() => {}}
                          onPaymentCompleted={finalizePayment}
                          installmentInfo={{
                            id: installmentId,
                            dueDate: scheduleDueDate()!
                          }}
                        />
                      </div>
                    </Collapse>
                  </div> */}

                  <div className={styles.boxHeader}>
                    <div
                      onClick={() => {
                        setPayMethod(PaymentMethod.dash)
                      }}
                    >
                      <h4>Pay with Dash</h4>
                    </div>
                    <Collapse in={payMethod === PaymentMethod.dash}>
                      <div>
                        <PayWithDash
                          amountPayable={installment.monthlyPayment}
                          isKYCDone={true}
                          onPayButtonClick={() => {}}
                          onPaymentCompleted={finalizePayment}
                          installmentInfo={{
                            id: installmentId,
                            dueDate: scheduleDueDate()!
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>

                  <div>
                    <div
                      onClick={() => {
                        setPayMethod(PaymentMethod.paynow)
                      }}
                    >
                      <h4>Pay with Paynow!</h4>
                    </div>
                    <Collapse in={payMethod === PaymentMethod.paynow}>
                      <div>
                        <PayWithPaynow
                          amountPayable={installment.monthlyPayment}
                          isKYCDone={true}
                          onPayButtonClick={() => {}}
                          onPaymentCompleted={finalizePayment}
                          installmentInfo={{
                            id: installmentId,
                            dueDate: scheduleDueDate()!
                          }}
                        />
                      </div>
                    </Collapse>
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Layout>
  )
}

export default PayNextInstallment
